import { StyleSheet, } from 'react-native';

const darkTheme = StyleSheet.create({
    closeModalIcon: {
        alignSelf: 'flex-end',
        position: 'absolute',
        top: 0,
        right: 0,
    },

    modal: {
        marginTop: 100,
        justifyContent: "center",
        alignItems: "center",
    },

    titleText: {
        fontSize: 20,
        fontWeight: '600',
        letterSpacing: -0.2,
        color: '#F2ECDC',
    },

    modalView: {
        height: 300,
    },

    startGameDifficulty: {
        flexDirection: 'row',
        width: 250,
        alignItems: 'center',
        justifyContent: 'center',
    },

    startGameButton: {
        width: 250,
        marginVertical: 8,
        borderRadius: 8,
        overflow: 'hidden',
    },

    modalButton: {
        width: '50%',
        marginLeft: '25%',
        marginTop: 10,
    },

    startGameContainer: {
        alignItems: 'center',
        justifyContent: 'center',
    },
    dominoBorder: {
        borderRightColor: '#2A2620',
        borderRightWidth: 1,
    },
    dominoPlayerText: {
        color: "#F2ECDC",
        fontSize: 9,
        fontWeight: '500',
        letterSpacing: 0.2,
        width: '105%',
        textAlign: 'center',
        marginBottom: 10,
    },
    instructionsText: {
        color: "#A89F8B",
        fontSize: 11,
        lineHeight: 16,
        width: '105%',
        textAlign: 'center',
        marginBottom: 10,
    },
    dominoPlayerTextJoin: {
        color: "#A89F8B",
        fontSize: 9,
        width: '105%',
        textAlign: 'center',
        marginBottom: 10,
        fontStyle: 'italic',
    },
    dominoScoreText: {
        color: "#F2ECDC",
        fontSize: 24,
        fontWeight: '600',
        letterSpacing: -0.3,
        width: '105%',
        textAlign: 'center',
        marginBottom: 10,
    },
    dominoPlayer: {
        width: 50,
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
        marginLeft: '1%',
        marginRight: '1%',
    },
    dominoPlayerPic: {
        resizeMode: 'cover',
        width: 50,
        height: 50,
        borderRadius: 25,
        marginBottom: 10,
        borderWidth: 1,
        borderColor: '#2A2620',
        overflow: 'hidden',
    },
    dominoPlayerButton: {
        width: 64,
        margin: 5,
        borderRadius: 8,
        overflow: 'hidden',
    },
    dominoTableHolder: {
        flexDirection: 'row',
    },
    dominoTableHolderButton: {
        flexDirection: 'row',
    },
    playButton: {
        marginTop: 12,
        marginBottom: 4,
        width: '100%',
        justifyContent: 'center',
        borderRadius: 8,
        overflow: 'hidden',
    },
    modalOverlay: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'rgba(0,0,0,0.65)',
    },
    stickToTop: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#14110C',
    },
    adCard: {
        marginHorizontal: '10%',
        width: '80vw',
        backgroundColor: '#1E1A14',
        borderRadius: 12,
        borderWidth: 1,
        borderColor: '#2A2620',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.4,
        shadowRadius: 8,
        elevation: 2,
    },
    newGameCard: {
        marginHorizontal: '10%',
        backgroundColor: '#1E1A14',
        borderRadius: 12,
        borderWidth: 1,
        borderColor: '#2A2620',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.4,
        shadowRadius: 8,
        elevation: 2,
    },
    dominoTable: {
        marginHorizontal: '10%',
        backgroundColor: '#1E1A14',
        borderRadius: 12,
        borderWidth: 1,
        borderColor: '#2A2620',
        borderLeftWidth: 3,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.4,
        shadowRadius: 8,
        elevation: 2,
    },
    dominoTableCutthroat: {
        borderLeftColor: '#E0AD49',
    },
    dominoTablePartner: {
        borderLeftColor: '#5BBF74',
    },
    dominoTableTitleRow: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingHorizontal: 4,
        paddingTop: 2,
        marginBottom: 8,
    },
    dominoTableTitle: {
        fontSize: 17,
        fontWeight: '600',
        letterSpacing: 0.2,
        color: '#F2ECDC',
        textTransform: 'capitalize',
    },
    statusPill: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: 8,
        paddingVertical: 3,
        borderRadius: 999,
    },
    statusPillWaiting: {
        backgroundColor: 'rgba(224,173,73,0.18)',
    },
    statusPillLive: {
        backgroundColor: 'rgba(91,191,116,0.16)',
    },
    statusPillText: {
        fontSize: 10,
        fontWeight: '600',
        letterSpacing: 0.6,
        textTransform: 'uppercase',
    },
    statusPillTextWaiting: {
        color: '#E0AD49',
    },
    statusPillTextLive: {
        color: '#5BBF74',
    },
    statusDot: {
        width: 6,
        height: 6,
        borderRadius: 3,
        marginRight: 6,
    },
    statusDotWaiting: {
        backgroundColor: '#E0AD49',
    },
    statusDotLive: {
        backgroundColor: '#5BBF74',
    },
    dominoPlayerEmpty: {
        width: 50,
        height: 50,
        borderRadius: 25,
        marginBottom: 10,
        borderWidth: 1,
        borderStyle: 'dashed',
        borderColor: '#3A352D',
        backgroundColor: 'rgba(91,191,116,0.06)',
        alignItems: 'center',
        justifyContent: 'center',
    },
    dominoPlayerEmptyPlus: {
        fontSize: 22,
        fontWeight: '300',
        color: '#6B6557',
        lineHeight: 24,
    },
    dominoScoreContainer: {
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 8,
    },
    dominoScoreLabel: {
        fontSize: 9,
        fontWeight: '600',
        letterSpacing: 1.2,
        color: '#6B6557',
        marginTop: -2,
    },
    teamDivider: {
        width: 1,
        marginHorizontal: 4,
        backgroundColor: '#5BBF74',
        opacity: 0.4,
    },
    newGameTitle: {
        fontSize: 18,
        fontWeight: '600',
        letterSpacing: 0.2,
        color: '#F2ECDC',
        marginBottom: 4,
    },
    newGameText: {
        marginBottom: 20,
        textAlign: 'center',
        color: '#A89F8B',
        lineHeight: 20,
    },
    newGame: {},
    textInputIcon: {
        height: 40,
        width: 50,
        backgroundColor: '#1E1A14',
        borderRadius: 8,
        borderWidth: 1,
        borderColor: '#2F2A22',
        paddingTop: 6,
    },
    textInputIconContainer: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 20,
    },
    spinnerContainer: {
        marginTop: 40,
    },
    logo: {
        resizeMode: 'contain',
        width: 250,
        height: 100,
    },
    primaryButtonStyle: {

    },
    textInputIconStyle: {
        height: 40,
        width: 200,
        backgroundColor: '#1E1A14',
        borderRadius: 8,
        borderWidth: 1,
        borderColor: '#2F2A22',
        paddingHorizontal: 10,
        color: '#F2ECDC',
    },
    textInputStyle: {
        height: 40,
        width: 250,
        marginBottom: 20,
        backgroundColor: '#1E1A14',
        borderRadius: 8,
        borderWidth: 1,
        borderColor: '#2F2A22',
        paddingHorizontal: 10,
        color: '#F2ECDC',
    },
    incorrectPasswordStyle: {
        height: 40,
        width: 250,
        marginBottom: 20,
        backgroundColor: 'rgba(142,22,0,0.18)',
        borderRadius: 8,
        borderWidth: 1,
        borderColor: '#5C2418',
        paddingHorizontal: 10,
        color: '#F2ECDC',
    },
    signupContainer: {
        flexDirection: 'row',
        flex: 1,
        marginTop: 28,
        marginBottom: 16,
        alignItems: 'center',
        justifyContent: 'center',
    },
    signupContainer2: {
        flexDirection: 'row',
        flex: 1,
        marginTop: 8,
        marginBottom: 8,
        alignItems: 'center',
        justifyContent: 'center',
    },
    formContainer: {
        marginTop: 20,
        alignItems: 'center',
        justifyContent: 'flex-start',
        flex: 6,
    },
    signupFormContainer: {
        marginTop: 20,
        alignItems: 'center',
        justifyContent: 'flex-start',
        flex: 12,
    },
    logoContainer: {
        alignItems: 'center',
        justifyContent: 'flex-end',
        flex: 5,
    },
    tabLogoContainer: {
        alignItems: 'center',
        backgroundColor: '#14110C',
    },
    profPic: {
        resizeMode: 'contain',
        width: 100,
        height: 100,
        borderRadius: 100 / 2,
    },
    adIframe: {

    },
    tabLogo: {
        resizeMode: 'contain',
        width: 125,
        height: 50,
    },
    tabLogo2: {
        resizeMode: 'contain',
        width: 64,
        height: 25,
    },
    labelText: {
        textAlign: 'left',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        margin: 0,
        padding: 0,
    },
    tabNavContainer: {

    },
    homeMenu: {
        backgroundColor: '#14110C',
    },
    playContent: {
        paddingBottom: '5%',
        backgroundColor: '#14110C',
    },
    container2: {
        flex: 1,
        backgroundColor: '#14110C',
    },
    container: {
        flex: 1,
        backgroundColor: '#14110C',
    },
    genericText: {
        color: '#F2ECDC',
        marginRight: 6,
    },
    genericText2: {
        color: '#F2ECDC',
        marginRight: 6,
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
    },
    buttonText: {
        color: '#5BBF74',
        fontWeight: '600',
        letterSpacing: 0.1,
    },
    errorText: {
        color: '#E57461',
        fontWeight: '500',
    },
    successText: {
        color: '#5BBF74',
    },

    item: {
        backgroundColor: '#f9c2ff',
        padding: 20,
        marginVertical: 8,
        marginHorizontal: 16,
    },
    title: {
        fontSize: 32,
    },
});

const darkStyleTheme = {
    placeholderTextColor: "#6B6557",
    primaryButtonColor: "#43A85A",
    negativeButtonColor: "#E57461",
    tabNavigation: {
        indicatorStyle: { backgroundColor: "#43A85A", height: 3, borderRadius: 2 },
        style: {
            backgroundColor: "#14110C",
        },
        innerHeight: 500,
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        activeTintColor: "#F2ECDC",
    },
};

export { darkTheme, darkStyleTheme };
